import { useEffect } from 'react'

import type { ApiError } from '../../gateways/api'
import { useAlerts } from '../../theme/hooks/useAlerts'

export const useQueryErrorAlert = (
  error: ApiError | null,
  errorUpdatedAt: number,
  title: string,
) => {
  const { errorAlert } = useAlerts()

  useEffect(() => {
    if (error) errorAlert(title, error)
  }, [error, errorUpdatedAt, errorAlert, title])
}
